import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { businessGameplayDetail, businessGameplayMapList } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import { template } from "lodash";
export default {
  name: "commercialPlaying",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      searchData: {
        server_id: "",
        role_id: "",
        page: 1,
        page_size: 10,
        state: ''
      },
      // currentPage: 1,
      // pageSize: 10,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      total: 0,
      serverList: [],
      statusList: [{
        label: this.$t('startStatus'),
        value: 1
      }, {
        label: this.$t('completeStatus'),
        value: 2
      }, {
        label: this.$t('failStatus'),
        value: 3
      }],
      mappList: []
    };
  },
  created: function created() {
    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    } //this.getMappingList()

  },
  mounted: function mounted() {},
  methods: {
    // getMappingList(){
    //   businessGameplayMapList({...this.paramsData,page_size: -1 }).then(res => {
    //     this.mappList = res.data
    //   })
    // },
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.searchData.starttime = this.value2[0];
      this.searchData.endtime = this.value2[1];
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.server_id = this.paramsData.server_id;
      this.reqLoading = true;
      businessGameplayDetail(searchData).then(function (res) {
        console.log(res);

        if (res.code == 200) {
          if (res.action) {
            _this.mappList = Object.keys(res.action).map(function (item) {
              return {
                label: item,
                value: res.action[item]
              };
            });
          }

          _this.tableData = res.data || [];
          _this.total = res.total ? parseInt(res.total) : 0;

          _this.tableData.forEach(function (item) {
            if (item.ext) {
              // item.ext = JSON.parse(item.ext);
              item.ext1 = Object.keys(item.ext).map(function (lev) {
                return {
                  name: lev,
                  num: JSON.stringify(item.ext[lev])
                };
              });
            }
          });

          console.log("this.tableData", _this.tableData); // this.currentPage = 1;
          // this.tableCopyTableList = JSON.parse(JSON.stringify(this.tableData));
          // this.tableData = this.currentChangePage(this.pageSize, this.currentPage);

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    getServer: function getServer() {
      var _this2 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      businessGameplayDetail(_objectSpread(_objectSpread({}, this.searchData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data || [];
          data.forEach(function (item) {
            item.state = item.state == 1 ? _this3.$t('startStatus') : item.state == 2 ? _this3.$t('completeStatus') : _this3.$t('failStatus');

            if (item.ext) {
              item.ext1 = '';
              Object.keys(item.ext).forEach(function (lev) {
                item.ext1 += "".concat(lev, ": ").concat(JSON.stringify(item.ext[lev]));
              });
            } // for (let k in item.resource) {
            //   item[k] = ""
            //   item.resource[k].forEach((a,index) => {
            //     item[k] += `${a.item_name}:${a.item_num}${index != item.resource[k].length-1?",":""}`
            //   })
            // }

          });
          var columns = [{
            label: _this3.$t('game'),
            prop: "game"
          }, {
            label: _this3.$t('platform'),
            prop: "platform"
          }, {
            label: _this3.$t('channel'),
            prop: "channel"
          }, {
            label: _this3.$t('pkg'),
            prop: "pkg"
          }, {
            label: _this3.$t('adChannel'),
            prop: "ad_channel"
          }, {
            label: _this3.$t('adPlacement'),
            prop: "ad_placement"
          }, {
            label: _this3.$t('serverId'),
            prop: "server_id"
          }, {
            label: _this3.$t('accountId'),
            prop: "user_id"
          }, {
            label: _this3.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this3.$t('roleName'),
            prop: "role_name"
          }, {
            label: _this3.$t('roleLevel'),
            prop: "level"
          }, {
            label: _this3.$t('playName'),
            prop: "action_name"
          }, {
            label: _this3.$t('status'),
            prop: "state"
          }, {
            label: _this3.$t('time'),
            prop: "time"
          }, {
            label: _this3.$t('extendedParams'),
            prop: "ext1"
          } // {label: '消耗',prop: 'cost'},
          // {label: '产出',prop: 'output'},
          // {label: '留存',prop: 'retain'},
          // {label: '游戏角色',prop: 'charactor'},
          ]; // let data = res.data.data;

          _this3.$export.excel({
            columns: columns,
            data: data,
            title: _this3.$route.meta.title
          });
        }
      });
    }
  }
};